export default __webpack_public_path__ + "static/media/002-cutlery.026bee15.svg";